

WB.WidgetGrids = WB.WidgetGrids || {};
WB.WidgetGrids.WidgetGridDirectiveLink = function($timeout) {
    return function (scope, element, attr) {
    };
};

WB.WidgetGrids.WidgetGridDirective = function($timeout) {
    return {
        scope: {
            grid: '='
        },
        restrict: 'AE',
        link: WB.WidgetGrids.WidgetGridDirectiveLink($timeout),
        template: `<div ng-if="grid.LayoutId == 1">
        <div
        wb-widget-grid-one
        grid="grid"></div>
    </div>
    <div ng-if="grid.LayoutId == 3">
        <div
        wb-widget-grid-three
        grid="grid"></div>
    </div>
    <div ng-if="grid.LayoutId != 1 && grid.LayoutId != 3">
        <div
        wb-widget-grid-default
        grid="grid"></div>
    </div>
    `
    };
};
WB.WidgetGrids.WidgetGridDirective.$inject = ['$timeout'];

WB.App.directive('wbWidgetGrid', WB.WidgetGrids.WidgetGridDirective);
